<template>
  <card-dialog
    v-model="modalVisible"
    max-width="400px"
    :persistent="false"
    :title="title"
  >
    <v-card-text class="pa-5">
      {{ text }}
    </v-card-text>

    <v-divider />

    <template v-slot:actions>
      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          color="grey"
          @click="modalVisible = false"
        >
          {{ $t('button.no_cancel') }}
        </v-btn>
        <v-btn
          color="error"
          :loading="submitting"
          @click="submit"
        >
          <v-icon
            small
            left
          >
            fa fa-check
          </v-icon>
          {{ ctaText }}
        </v-btn>
      </v-card-actions>
    </template>
  </card-dialog>
</template>

<script>

import CardDialog from '@/components/helpers/CardDialog.vue'
import i18n from '@/plugins/i18n'

export default {
    name: 'DeleteConfirmationDialog',
    components: {
      CardDialog
    },
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      text: {
        type: String,
        default: i18n.t('delete_confirm.info')
      },
      title: {
        type: String,
        default: i18n.t('delete_confirm.dialog.header')
      },
      ctaText: {
        type: String,
        default: i18n.t('button.yes_delete')
      },
      submitting: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      modalVisible: {
        get: function () {
          return this.visible
        },
        set: function (value) {
          this.$emit('update:visible', value)
        }
      }
    },
    watch: {
      visible(value) {
        if (value) {
          window.addEventListener('keyup', this.eventListener)
        } else {
          window.removeEventListener('keyup', this.eventListener)
        }
      }
    },
    beforeDestroy() {
      window.removeEventListener('keyup', this.eventListener)
    },
    created() {
      const self = this

      this.eventListener = function (ev) {
        if (ev.key === 'Enter') {
          self.submit()
          return
        }

        if (ev.key === 'Escape') {
          this.modalVisible = false
        }
      }
    },
    methods: {
      submit() {
        this.$emit('confirmed')
      }
    }
  }
</script>

<style scoped>

</style>
